import request from '@/utils/request';
const querystring = require('querystring')

//获取列表数据
export const fetchListData = query => {
    var list = request({
        url: 'comOrderSettlement/selectListByGroup.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//获取列表数据
export const fetchData = query => {
    var list = request({
        url: 'comOrderSettlement/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

//启用-禁用
export const changeStatus = query => {
    var list = request({
        url: 'comOrderSettlement/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//添加渠道信息
export const saveForm = query => {
    var list = request({
        url: 'comOrderSettlement/insert.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDelete = query => {
    var list = request({
        url: 'comOrderSettlement/delete.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDeleteMore = query => {
    var list = request({
        url: 'comOrderSettlement/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handUpdateMore = query => {
    var list = request({
        url: 'comOrderSettlement/updateMore.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const changeForm = query => {
    var list = request({
        url: 'comOrderSettlement/update.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const fetchSelect = query => {
    var list = request({
        url: 'comOrderSettlement/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const downCashExcel = query => {
    var list = request({
        url: 'comOrderSettlement/downCashExcel.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const getSumSettlement = query => {
    var list = request({
        url: 'comOrderSettlement/getSumSettlement.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const getDataByChannelCash = query => {
    var list = request({
        url: 'comOrderSettlement/getDataByChannelCash.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const updateSettlStatus = query => {
    var list = request({
        url: 'comOrderSettlement/updateSettlStatus.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const changeCpa = query => {
    var list = request({
        url: 'comOrderSettlement/changeCpa_back.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const updateSettle = query => {
    var list = request({
        url: 'comOrderSettlement/updateSettle.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const updateDeduction = query => {
    var list = request({
        url: 'comOrderSettlement/updateDeduction.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};



